import walmartLogo from "/img/integration/walmart.png"
import { ConnectLogo } from "../connect-logo"
import { Button } from "@/components/ui/button.tsx"
import { CenterColumnContainer } from "@/components/LoginScreen.tsx"
import { useState } from "preact/compat"
import { useLocation } from "wouter-preact"
import { use_connect_redirect_to } from "../use_connect_redirect_to"
import { HighRadiusLoginSection } from "../walmart/highradius_section"

/**
 * Add (or change) the HighRadius login on its own — for a brand whose Walmart connection already
 * exists, or one that uploads its Retail Link export and has no bot account.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ConnectWalmartHighRadiusPage(props: any = {}) {
  const redirectTo = use_connect_redirect_to(props.redirectTo)
  const [, setLocation] = useLocation()
  const [saved, setSaved] = useState(false)

  return (
    <CenterColumnContainer>
      <div class="space-y-6">
        <ConnectLogo src={walmartLogo} alt="Walmart" />
        <h3 class="text-base font-semibold text-gray-900 text-center">Walmart HighRadius</h3>
        <HighRadiusLoginSection onSaved={() => setSaved(true)} />
        <Button
          class="w-full bg-gray-900 text-white rounded-lg hover:bg-gray-800"
          onClick={() => setLocation(redirectTo)}>
          {saved ? "Done" : "Back"}
        </Button>
      </div>
    </CenterColumnContainer>
  )
}
